<template>
  <div class="Sac-Principal">
    <PageTitle
      icon="fa fa-phone"
      main="Tickets de chamados"
      sub="Atendimento aos colaboradores"
    />
    <div class="Sac-Principal">
      <b-card no-body>
        <b-tabs>
          <b-tab title="Abertura"><SacChamado /></b-tab>
          <b-tab title="Encerramento"><SacChamadoEncerramento /></b-tab>
          <b-tab title="Indicadores"><SacChamadoPainel /></b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import SacChamado from "../sac_chamado/SacChamado";
import SacChamadoEncerramento from "../sac_chamado/SacChamadoEncerramento";
import SacChamadoPainel from "../sac_chamado/SacChamadoPainel";
export default {
  name: "SacPrincipal",
  components: {
    PageTitle,
    SacChamado,
    SacChamadoEncerramento,
    SacChamadoPainel,
  },
};
</script>

<style>
</style>






